module.exports = __webpack_public_path__ + "img/project_icon_seven.387fecf4.png";